import { FC } from 'react';
import classNames from 'classnames';

import { IconWrapperComponent } from '@hh.ru/magritte-ui-icon';
import {
    LoaderOutlinedSize16,
    LoaderOutlinedSize24,
    LoaderOutlinedSize64,
    LoaderOutlinedSize96,
} from '@hh.ru/magritte-ui-icon/icon';
import { type LoaderSize, type LoaderProps } from '@hh.ru/magritte-ui-loader/types';

import styles from './loader.less';

const iconsBySize = new Map<LoaderSize, IconWrapperComponent>([
    [16, LoaderOutlinedSize16],
    [24, LoaderOutlinedSize24],
    [64, LoaderOutlinedSize64],
    [96, LoaderOutlinedSize96],
]);

export const Loader: FC<LoaderProps> = ({ size = 16, 'aria-label': ariaLabel = 'loading', ...props }) => {
    const Element = iconsBySize.get(size);

    if (!Element) {
        return null;
    }

    const baseProps = {
        'aria-label': ariaLabel,
        ...props,
    };

    return (
        <span
            className={classNames(styles.loader, {
                [styles.internal_overriden]: !props.initial,
            })}
            role="status"
            data-qa="magritte-loader"
        >
            <Element {...baseProps} />
        </span>
    );
};
